import { StoreProviderService } from 'src/app/_core/services/store.provider.service';

export function Dispatch(action: any | any[]) {
    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    return function(target, name, descriptor: PropertyDescriptor) {
        if (descriptor.value !== null) {
            const originalFn = descriptor.value;
            const newDescriptor = {
                configurable: true,
                get() {
                    const store = StoreProviderService.store;
                    if (store) {
                        store.dispatch(action);
                    }
                    return originalFn;
                }
            };
            // Add hidden property to descriptor
            (newDescriptor as any).originalFn = originalFn;
            return newDescriptor;
        } else {
            throw new Error('Dispatch only work on methods');
        }
    };
}
